/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        menu: {
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "6px",
                            blur: "16px",
                            spread: "-4px",
                            color: "#00000020",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "5px",
                            blur: "8px",
                            spread: "-8px",
                            color: "#00000008",
                        },
                    ],
                    stringValue: "0px 6px 16px -4px #00000020, 0px 5px 8px -8px #00000008",
                },
                type: "shadow",
            },
            item: {
                gap: {
                    value: "16px",
                    type: "dimension",
                },
                height: {
                    value: "48px",
                    type: "dimension",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
                paddingHorizontal: {
                    value: "16px",
                    type: "dimension",
                },
                hover: {
                    backgroundColor: {
                        value: "#EBEEF2",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#94949452",
                        type: "color",
                    },
                },
                destructive: {
                    color: {
                        value: "#AF292E",
                        type: "color",
                    },
                },
                selected: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
